<template>
  <span class="l-spacing-half reduced-price c-gray">
    <span
      v-if="originalPriceFormatted"
      v-html="originalPriceFormatted"
      class="mr-1"
    />
    <del v-else class="mr-1">{{ currency(originalPrice) }}</del>
    <span>{{ translate('fe_app_pdp_srp') }}</span>
  </span>
</template>

<script>
export default {
  props: {
    originalPrice: [String, Number],
    originalPriceFormatted: String
  }
}
</script>
